import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {DatevNotificationService, DatevNotificationSeverity} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';
import {ComponentHelper, DeleteHelperService, TaskDataService, WizardPageBaseComponent} from '@utils-lib';
import {LoaderService} from '../service/loader.service';
import {AttachmentService} from '../service/attachment.service';
import {AttachmentsComponent} from '../component/attachments/attachments.component';

@Injectable()
export class WizardpageDeactivateGuard implements CanDeactivate<WizardPageBaseComponent<unknown>> {

    constructor(
        private readonly taskDataService: TaskDataService,
        private readonly notificationService: DatevNotificationService,
        private readonly translateService: TranslateService,
        private readonly deleteHelperService: DeleteHelperService,
        private readonly attachmentService: AttachmentService,
        public readonly loadingService: LoaderService) {
    }

    public canDeactivate(
        component: WizardPageBaseComponent<unknown>,
        currentRoute: ActivatedRouteSnapshot): Observable<boolean> {

        this.loadingService.isLoading = {isLoading: false};


        this.notificationService.close('putNutzdatenError');

        // im readonly-Modus wird nicht gespeichert
        if (component && component.readonly) {
            return of(true);
        }

        if (this.deleteHelperService.flag) {
            this.deleteHelperService.flag = false;
            return of(true);
        }

        if(component instanceof AttachmentsComponent){
          this.attachmentService.saveUserEmail(component.taskId, component.data.email.email).subscribe();
          return of(true);
        }

        const datatype = ComponentHelper.getNutzdatenPath(currentRoute);

        return this.taskDataService.putNutzdaten(datatype, component.data).pipe(
            map(() => true),
            catchError(() => {
                this.notificationService.showAlert(DatevNotificationSeverity.Error,
                    this.translateService.instant('COMMON_UI.NOTIFICATIONS.SAVE_ERROR.TITEL'),
                    null,
                    this.translateService.instant('COMMON_UI.NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
                    [{id: 'putNutzdatenErrorOk', label: 'OK'}],
                    'putNutzdatenError');

                return of(false);
            }));
    }
}
